/* unplugin-vue-components disabled */import { render } from "./item-mm-drag.vue?vue&type=template&id=cad5cba8"
import script from "./item-mm-drag.vue?vue&type=script&lang=js"
export * from "./item-mm-drag.vue?vue&type=script&lang=js"

import "./item-mm-drag.vue?vue&type=style&index=0&id=cad5cba8&lang=less&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__